import { OrganizationSwitcher, useOrganizationList } from '@clerk/clerk-react';

const ORGANIZATION_SWITCHER_STYLES = {
  elements: {
    rootBox: {
      width: '100%',
      display: 'flex',
    },
    notificationBadge: {
      display: 'none',
    },
    organizationSwitcherTrigger: {
      width: '100%',
      padding: '8px 16px',
      display: 'flex',
      justifyContent: 'space-between',
      '&:hover': {
        background: 'var(--brand-500)',
      },
    },
    organizationSwitcherPopoverCard: {
      display: 'block',
    },
    organizationSwitcherPopoverInvitationActions: {
      display: 'none',
    },
    organizationPreviewMainIdentifier__organizationSwitcherTrigger: {
      color: 'var(--foreground)',
      fontSize: '14px',
    },
    organizationSwitcherPopoverFooter: {
      display: 'none',
    },
    organizationSwitcherPopoverActionButton__createOrganization: {
      display: 'none',
    },
    organizationSwitcherPopoverActionButton__manageOrganization: {
      display: 'none',
    },
  },
} as const;

export const CustomOrganizationSwitcher = () => {
  const { isLoaded } = useOrganizationList({
    userMemberships: { infinite: true, keepPreviousData: true },
  });

  if (!isLoaded) {
    return null;
  }

  return (
    <OrganizationSwitcher
      hidePersonal
      appearance={ORGANIZATION_SWITCHER_STYLES}
    />
  );
};
